import React from 'react';
import { SdfAlert, SdfShimmer } from '@synerg/react-components';
import { RequestManageCertficate } from '../certificate/certificateAlert';

function ProjDetailCertAlert({ allCertsInfo }) {

  const getCertificateText = (certNumber) => {
    return certNumber === 1 ? "certificate" : "certificates";
  }

  if (!allCertsInfo.loading) {
    if (allCertsInfo.certificates instanceof Error) {
      return (
        <SdfAlert status='error' size='sm' aria-live="polite" className="mb-2">
          <span slot="title"> Difficulty retrieving certificate information </span>
          <div>There was an error retrieving your certificate information.</div>
        </SdfAlert>
      )
    }

    if (allCertsInfo.certificates.length > 0) {
      return (
        <SdfAlert status='info' size='sm' aria-live="polite">
          {allCertsInfo.certsDetails.activeCerts > 0 && allCertsInfo.certsDetails.expiredCerts === 0 && <RequestManageCertficate alertTitle={"Certificate generated/uploaded"} alertBody={`You currently have ${allCertsInfo.certsDetails.activeCerts} active ${getCertificateText(allCertsInfo.certsDetails.activeCerts)} on file.`} request={false} isProjectDetailPage={true} />}

          {allCertsInfo.certsDetails.activeCerts > 0 && allCertsInfo.certsDetails.expiredCerts > 0 && <RequestManageCertficate alertTitle={"Certificate generated/uploaded"} alertBody={`You currently have ${allCertsInfo.certsDetails.activeCerts} active ${getCertificateText(allCertsInfo.certsDetails.activeCerts)} and ${allCertsInfo.certsDetails.expiredCerts} expired ${getCertificateText(allCertsInfo.certsDetails.expiredCerts)} on file.`} request={false} isProjectDetailPage={true} />}

          {allCertsInfo.certsDetails.activeCerts === 0 && <RequestManageCertficate alertTitle={"Request or upload security certificate"} alertBody={`A signed certificate from ADP is required to retrieve an access token.`} request={allCertsInfo.certificates.length < 10 && true} isProjectDetailPage={true} />}
        </SdfAlert>
      )
    }

    else {
      return (
        <SdfAlert status='info' size='sm' aria-live="polite">
          <RequestManageCertficate alertTitle={"Request or upload security certificate"} alertBody={`A signed certificate from ADP is required to retrieve an access token.`} request={true} isProjectDetailPage={true} />
        </SdfAlert>
      )
    }
  }

  else {
    return (<div>
      <SdfShimmer rows={4} />
    </div>)
  }
}

export default ProjDetailCertAlert;

